import React from 'react';
import cn from 'classnames';
import { DH } from '../../utils/DataHook';
import { Spinner } from '../Spinner';
import * as s from './styles.scss';

export interface LoaderProps {
  dataHook?: string;
  size?: 'small' | 'medium';
  color?: 'black' | 'white';
  isExpanded?: boolean;
}

export const Loader: React.FunctionComponent<LoaderProps> = (props) => {
  const { dataHook = DH.Loader, size, color, isExpanded = true } = props;

  return (
    <div data-hook={dataHook} className={cn(isExpanded && s.loaderWrap)}>
      <Spinner size={size} color={color} />
    </div>
  );
};
Loader.displayName = 'Loader';
